import { gql } from "@apollo/client";

export const QUERY_INTERVENTIONS_DATA = gql`
  query getInterventionsData {
    getInterventionsData {
      addedLaps
      flagPeriods {
        type
        startTime
        endTime
        duration
      }
      cutoffTime
    }
  }
`;

export const SUBSCRIBE_NEW_INTERVENTIONS_DATA = gql`
  subscription newInterventionsData {
    newInterventionsData {
      addedLaps
      flagPeriods {
        type
        startTime
        endTime
        duration
      }
      cutoffTime
    }
  }
`;
